<template lang="pug">
  .pm-page
    .page-frame.page-frame-top
      .row
        //.columns.shrink(v-if="userAuthenticated")
          //ul.dropdown.menu(data-dropdown-menu='')
            li.menu-text
            //  a.button.small.menu-button(data-toggle='offCanvasLeft') Menu
        .columns.text-center
          img.topbar-main-logo(:src="logo")
    .top-bar.show-for-large(v-if="title")
      .top-bar-left.text-center
        span {{time}}
        //a.button.small.menu-button(data-toggle='offCanvasRight') Menu2
      .top-bar-right
        span {{ title }}
        span &nbsp;
        i(style="cursor:pointer;", @click="reload").fa.fa-retweet
    .off-canvas
      // Top Bars
      .off-canvas-wrapper(data-off-canvas-wrapper='')
        #offCanvasLeft.off-canvas-absolute.position-left.reveal-for-large(data-off-canvas='', v-f-off-canvas='', v-if="userAuthenticated")
          // Close button
          .show-for-small-only(style="min-height:50px")
            button.close-button(aria-label='Close menu', type='button', data-close='')
              span(aria-hidden='true') &times;
          // Menu
          ul.vertical.menu
            router-link(v-for='item in menu_pages', :to='{ name: item.name }' tag="li", :class="item.name")
              a {{ item.display_name }}
              ul(v-if="item.childrens")
                li(v-for="child in item.childrens")
                  router-link(:to='{ name: child.name }') {{ child.display_name }}
            li.no-icon.router-link-active
              a(href='#') Profile
              ul
                li
                  div
                    small
                      span {{userStore.username}} (ID: {{userStore.id}})
                  div
                    small
                      span {{userStore.email}}
            li.no-icon.router-link-active
              a(href='#') Extra
              ul
                li(v-for="page in extra_pages")
                  a(:href="page.url" target="_blank") {{ page.name }}
        .title-bar.hide-for-large
          .title-bar-left.row.align-middle.align-center
            button.menu-icon(type='button', data-toggle='offCanvasLeft')
            span.title-bar-title {{title}}
            i(style="cursor:pointer;", @click="reload").fa.fa-2x.fa-retweet

        #offCanvasRight.offCanvasBig.off-canvas-absolute.position-right(data-off-canvas='', v-f-off-canvas='', v-if="userAuthenticated")
          // Close button
          button.close-button(aria-label='Close menu', type='button', @click="destroy" data-close='')
            span(aria-hidden='true') &times;
          // Menu
          component(v-if="component", :is="component.component", v-bind="component.props")
        .off-canvas-content(data-off-canvas-content='')
          #customCanvas(v-if="component && component.position === 'top'")
            button.close-button(aria-label='Close menu', type='button', @click="destroy" data-close='')
              span(aria-hidden='true') &times;
            .container
              .row
                .column
                  component(:is="component.component", v-bind="component.props")
          .row(v-if="userAuthenticated")
            .columns.small-12.large-10
              breadcrumbs(v-if="!hideForAcl")
            .columns
              .side-actions
                QuickSearch
              .side-actions( v-for="act in this.$route.meta.action", :is="act.component", type="act", :item="act")
              .side-actions(v-if="action && !hideForAcl", :is="action.component", type="action", :item="action")
          #preloader.is-hidden
          router-view(:key="$route.fullPath")
        .rw

        //.footer
            .row.columns.text-center
                img(src="http://www.playmoove.com/wp-content/uploads/2016/07/footer-300x81.png")

</template>

<script>
import MaggieHelper from '../../maggieHelper'
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import {mapState} from "vuex";
import SearchEntity from "./ui/SearchEntity.vue";
import QuickSearch from "./ui/QuickSearch.vue";

export default {
  name: 'OffCanvas',
  components: {QuickSearch, SearchEntity},
  data() {
    return {
      component: null,
      userAuthenticated: MaggieHelper.isAdminLoggedIn(),
      time: null,
      extra_pages: [],
      searchOpen: false
    }
  },
  props: ['menu_pages', 'title', 'action'],
  computed: {
    logo() {
      if (window && window.env) {
        return window.env.LOGO
      }
    },
    hideForAcl() {
      return this.$route.name === 'plans' && !this.$acl('index-plan')
    },
    ...mapState({
      userStore: state => state.userStore.user,
    }),
  },
  methods: {
    getTime() {
      this.time = this.$dateFormat(new Date(), 'DD-MM-YYYY [ore] HH:mm:ss')
    },
    closeMenu() {
      $('#offCanvasLeft').foundation('close')
    },
    destroy() {
      this.component = null
    },
    reload() {
      window.location.reload(true)
    },
    gotoEntity(id, entity) {
      switch (entity) {
        case 'clients':
          this.$router.push({name: 'client', params: {id}})
          break;
        case 'drivers':
          this.$router.push({name: 'driver', params: {id}})
          break
      }

      this.searchOpen = false
    }
  },
  mounted() {
    KeplerBackofficeSdk.configuration.get((data) => {
      this.extra_pages = data.backoffice.backoffice_extra_menu_links.value
    })


    this.getTime()
    MaggieHelper.registerCallback((payload) => {
      switch (payload.position) {
        case 'right':
          $('#offCanvasRight').foundation('toggle')
          break
        case 'top':
          //$('#offCanvasTop').foundation('toggle')
          break
      }
      this.component = payload
    })
  },
  updated() {
    this.userAuthenticated = MaggieHelper.isAdminLoggedIn()
  },

  watch: {
    time() {
      setTimeout(this.getTime, 2000)
    }
  }
}

</script>
<style lang="sass" rel="stylesheet/sass">
.pm-page
  .is-open + .title-bar
    padding-left: 200px

  ///#customCanvas
    position: absolute
    z-index: 99
    left: 0
    right: 0
    padding-top: 2em
    padding-bottom: 2em
    background: rgba(255, 255, 255, 0.70)
  .off-canvas
    outline: 0
    display: flex
    flex-direction: column
    position: relative
  .topbar-main-logo
    height: 100%
    width: auto
    max-height: 6.5em
    padding: 0.75em 0

  .side-actions
    position: relative
</style>



// WEBPACK FOOTER //
// OffCanvas.vue?47ef2a9e